import { t } from '@lingui/core/macro';
import { Select } from '@pocketlaw/tetris';
import { useField, useFormikContext } from 'formik';
import { useEsigningAuthenticationModes } from 'app/domains/esigning/hooks/useEsigningAuthenticationModes';
import { getAuthenticationModeTitle } from 'app/domains/esigning/utils';
import { EsigningRecipientType } from 'shared/domains/apollo/generated/types';
import { ErrorMessage } from 'shared/domains/forms/components/ErrorMessage';
import { FieldWrapper } from '../../styled';
const FIELD_NAME = 'authenticationMode';
export function AuthenticationModeSelect() {
    const { authenticationModes } = useEsigningAuthenticationModes();
    const { submitCount } = useFormikContext();
    const [field, meta] = useField(FIELD_NAME);
    const [type] = useField('type');
    const error = Boolean(meta.error && meta.touched) || Boolean(meta.error && submitCount > 0);
    const disableField = type.value !== EsigningRecipientType.Signatory;
    if (authenticationModes.length === 0) {
        return null;
    }
    return (<FieldWrapper>
      <Select stretch disabled={disableField} invalid={error} {...field} label={t({
            comment: 'eSigning recipient form field - Authentication',
            message: 'Authentication',
        })} placeholder={t({
            comment: 'Select eSigning recipient authentication placeholder label',
            message: 'Select authentication',
        })}>
        {authenticationModes.map(({ slug }) => (<option key={slug} value={slug}>
            {getAuthenticationModeTitle(slug)}
          </option>))}
      </Select>
      <ErrorMessage name={FIELD_NAME}/>
    </FieldWrapper>);
}
